import { configureStore } from "@reduxjs/toolkit";
import businessApi from "store/apis/businessApi";
import businessListApi from "store/apis/businessListApi";
import defaultAccountApi from "store/apis/defaultAccountApi";
import userApi from "store/apis/userApi";
import businessReducer from "store/slices/businessSlice";
import defaultAccountReducer from "store/slices/defaultAccountSlice";
import topUpHistoryReducer from "store/slices/topUpHistorySlice";

export const store = configureStore({
  reducer: {
    businesses: businessReducer,
    defaultAccount: defaultAccountReducer,
    topUpHistory: topUpHistoryReducer,
    [defaultAccountApi.reducerPath]: defaultAccountApi.reducer,
    [businessListApi.reducerPath]: businessListApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [businessApi.reducerPath]: businessApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      defaultAccountApi.middleware,
      businessListApi.middleware,
      userApi.middleware,
      businessApi.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
